import React, { useState } from "react";
import styled from "styled-components";
import fowardWhite from "../../assets/fowardWhite.png";

const Container = styled.div`
  padding: 10px;
  max-width: 700px;
  margin-left: 50px;
  position: relative;
  margin-top: 10px;
`;

const Titulo = styled.h2`
  font-size: 16px;
  color: #FF9F1F;
  font-weight: 600;
  margin-bottom: 20px;
`;

const Grupo = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  display: block;
  font-size: 13px;
  color: #002E3B;
  margin-bottom: 5px;
  font-weight: bold;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 10px;
  outline: none;
`;

const Select = styled.select`
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 10px;
  outline: none;
  background-color: white;
  color: #002E3B;
`;

const Linha = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
`;

const Coluna = styled.div`
  flex: ${(props) => props.flex || 1};
`;

const BotaoAvancar = styled.button`
  background-color: #6AB8A8;
  color: white;
  font-size: 16px;
  font-weight: bold;
  padding: 8px 20px;
  border: none;
  border-radius: 8px;
  box-shadow: 0px 5px 3px rgba(0,0,0,0.3);
  cursor: pointer;
  position: absolute;
  bottom: -40px;
  right: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const FormularioEstabelecimentoSaude = ({ onNext }) => {
  const [data, setDados] = useState({
    tipoEstabelecimento: "",
    nomeEstabelecimento: "",
    nomeDiretor: "",
    cargoDiretor: "",
    nomeDiretorTecnico: "",
    cargoDiretorTecnico: "",
    nomeResponsavelEstagio: "",
    cargoResponsavelEstagio: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDados((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onNext(data);
  };

  return (
    <Container>
      <Titulo>Preecha os dados do estabelecimento de saúde</Titulo>

      <form onSubmit={handleSubmit}>
        <Grupo>
          <Label>Estabelecimento de saúde*</Label>
          <Select
            name="tipoEstabelecimento"
            value={data.tipoEstabelecimento}
            onChange={handleChange}
            required
          >
            <option value="">Selecione uma opção</option>
            <option value="hospital">Hospital</option>
            <option value="clinica">Clínica</option>
            <option value="laboratorio">Laboratório</option>
          </Select>
        </Grupo>

        <Grupo>
          <Label>
            Nome do estabelecimento de saúde (unidade da SES concedente do estágio)
          </Label>
          <Input
            name="nomeEstabelecimento"
            value={data.nomeEstabelecimento}
            onChange={handleChange}
            placeholder="Digite o nome do estabelecimento"
          />
        </Grupo>

        <Linha>
          <Coluna flex={3}>
            <Label>Nome do diretor</Label>
            <Input
              name="nomeDiretor"
              value={data.nomeDiretor}
              onChange={handleChange}
            />
          </Coluna>
          <Coluna>
            <Label>Cargo</Label>
            <Input
              name="cargoDiretor"
              value={data.cargoDiretor}
              onChange={handleChange}
            />
          </Coluna>
        </Linha>

        <Linha>
          <Coluna flex={3}>
            <Label>Nome do diretor técnico</Label>
            <Input
              name="nomeDiretorTecnico"
              value={data.nomeDiretorTecnico}
              onChange={handleChange}
            />
          </Coluna>
          <Coluna>
            <Label>Cargo</Label>
            <Input
              name="cargoDiretorTecnico"
              value={data.cargoDiretorTecnico}
              onChange={handleChange}
            />
          </Coluna>
        </Linha>

        <Linha>
          <Coluna flex={3}>
            <Label>Nome do responsável pelo setor de estágio</Label>
            <Input
              name="nomeResponsavelEstagio"
              value={data.nomeResponsavelEstagio}
              onChange={handleChange}
            />
          </Coluna>
          <Coluna>
            <Label>Cargo</Label>
            <Input
              name="cargoResponsavelEstagio"
              value={data.cargoResponsavelEstagio}
              onChange={handleChange}
            />
          </Coluna>
        </Linha>

        <BotaoAvancar type="submit">
          Próximo
          <img src={fowardWhite} alt="Avançar" width="20" />
        </BotaoAvancar>
      </form>
    </Container>
  );
};

export default FormularioEstabelecimentoSaude;
